import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHRecipeCopyType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.recipeCopy.sortFields,
		columnFields: constants.wholeHouse.recipeCopy.columnFields,
		standardFilterFields: constants.wholeHouse.recipeCopy.standardFilterFields,
		dateFilterFields: constants.wholeHouse.recipeCopy.dateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.recipeCopy.columnFields,
	filterIds: constants.wholeHouse.recipeCopy.filterFields,
});
